import { render, staticRenderFns } from "./material-market.vue?vue&type=template&id=5c537af8&scoped=true&"
import script from "./material-market.vue?vue&type=script&lang=js&"
export * from "./material-market.vue?vue&type=script&lang=js&"
import style0 from "./material-market.vue?vue&type=style&index=0&id=5c537af8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c537af8",
  null
  
)

export default component.exports